import { Component } from '@angular/core';

/**
 * The topbar wordmark: the Sakai-era logo glyph plus the product name. Split out
 * of AppTopbar because the inline SVG path data dwarfed everything else in that
 * component's template. Purely presentational — no inputs, no state.
 */
@Component({
    selector: 'app-brand-logo',
    standalone: true,
    templateUrl: './app.brand-logo.html',
    host: { class: 'contents' },
})
export class AppBrandLogo {}
